export const premisesDatacenter = {
  name: "premises-datacenter" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.6 4.5a.9.9 0 0 1 .9-.9h15a.9.9 0 0 1 .9.9v15a.9.9 0 0 1-.9.9h-15a.9.9 0 0 1-.9-.9v-15Zm1.8.9v13.2h4.2v-3.1a.9.9 0 0 1 .9-.9h3a.9.9 0 0 1 .9.9v3.1h4.2V5.4H5.4Zm7.2 13.2v-2.2h-1.2v2.2h1.2Zm-5-10.1a.9.9 0 0 1 .9-.9h7a.9.9 0 0 1 0 1.8h-7a.9.9 0 0 1-.9-.9Zm0 3.5a.9.9 0 0 1 .9-.9h7a.9.9 0 0 1 0 1.8h-7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["premises-datacenter"],
  category: "buildings" as const,
};
